import { AuthenticationContext } from "@/app/context/authentication/authenticationContext";
import { FriendsContext } from "@/app/context/friends/friendsContext";
import { NotificationContext } from "@/app/context/notification/notificationContext";
import { FocusableElement } from "@chakra-ui/dom-utils";
import { AlertDialog, AlertDialogContent } from "@chakra-ui/modal";
import { Alert, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, AlertIcon, Button, CloseButton, useToast } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import React, { MouseEventHandler, MutableRefObject, useContext } from "react";

type Props = {
    isOpen: boolean
    onClose: MouseEventHandler<HTMLButtonElement> | undefined
}

export const ConfirmDeleteFriend = () => {
    const cancelRef: MutableRefObject<FocusableElement | undefined> = React.useRef()
    const { t } = useTranslation();

    const {
        cloudStorage
    } = useContext(AuthenticationContext)

    const {
       showDeleteFriendRequestUserId,
       setShowDeleteFriendRequestUserId,
    }= useContext(FriendsContext)

    const {
        addError,
    } = useContext(NotificationContext)

    const onClose = ()=>{
        setShowDeleteFriendRequestUserId("")
    }

    const onDelete = async()=> {
        const check = await cloudStorage?.updateFriendRequests(showDeleteFriendRequestUserId,"rejected")
        if ( check ) {
            addError(t("friends.friendRequestRejected"),"info")
        }else{
            addError(t("friends.error"),"error")
        }
        setShowDeleteFriendRequestUserId("")
    }

    return(
        <AlertDialog
            isCentered
            isOpen={!!showDeleteFriendRequestUserId}
            leastDestructiveRef={cancelRef as MutableRefObject<any>}
            onClose={()=>onClose}
        >
            <AlertDialogOverlay>
                <AlertDialogContent
                >
                    <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                        {t("friends.deleteFriendRequest.question")}
                    </AlertDialogHeader>

                    <AlertDialogBody>
                        {t("friends.confirmDelete")}
                    </AlertDialogBody>

                    <AlertDialogFooter>
                        <Button
                            size="sm"
                            ref={cancelRef as MutableRefObject<any>}
                            onClick={onClose}>
                            {t("friends.deleteFriendRequest.no")}
                        </Button>
                        <Button size="sm" colorScheme='red' onClick={onDelete} ml={3}>
                            {t("friends.deleteFriendRequest.yes")}
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    )
}
